<template>
  <modal
    name="addusermodal"
    :width="modalWidth"
    :minHeight="200"
    :minWidth="200"
    :maxWidth="1300"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-end pt-3">
        <button type="button" @click="closeModal" class="close">
          <span aria-hidden="true">
            <font-awesome-icon icon="times" size="1x" />
          </span>
        </button>
      </div>

      <form class="mt-3" v-on:submit.prevent="saveEmp">
        <div class="row my-2 flex-column flex-md-row">
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>First name *</label>
            <input
              class=""
              type="text"
              v-model="employeeDetails.first_name"
              required
              :disabled="disableFields"
            />
          </div>

          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Last name *</label>
            <input
              type="text"
              v-model="employeeDetails.last_name"
              required
              :disabled="disableFields"
            />
          </div>

          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Email *</label>
            <input
              type="email"
              v-model="employeeDetails.email"
              @blur="checkEmail"
              required
            />
          </div>
        </div>

        <div class="row flex-column flex-md-row my-2">
          <div
            :class="{
              'col-12 col-md-4 form-group edit-modal-item low-opacity': true,
              'full-opacity': officeTeams && officeTeams.length > 0
            }"
          >
            <label>Team *</label>

            <select
              class="form-control"
              v-model="employeeDetails.team"
              :required="officeTeams.length > 0"
            >
              <option value="" selected disabled>Select a team</option>
              <option
                v-for="team in officeTeams"
                :key="team.id"
                :value="team.id"
                >{{ team.attributes.name }}</option
              >
            </select>
          </div>

          <div class="col-12 col-md-3 form-group edit-modal-item">
            <label>Title</label>
            <input type="text" v-model="employeeDetails.designation" />
          </div>
        </div>

        <div class="row flex-column flex-md-row my-2">
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 1</label>
            <select v-model="employeeDetails.first_reminder">
              <option selected value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 2</label>
            <select v-model="employeeDetails.second_reminder">
              <option :selected="true" value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 3</label>
            <select v-model="employeeDetails.third_reminder">
              <option :selected="true" value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-2 flex-column flex-md-row align-items-center">
          <div
            class="d-flex flex-column col-12 col-md-4 form-group edit-modal-item"
          >
            <label>Subsidy Type *</label>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center mr-4">
                <input
                  class="mr-2"
                  type="radio"
                  id="daily"
                  value="daily"
                  v-model="employeeDetails.subsidy_type"
                />
                <label for="daily">Daily</label>
              </div>

              <div class="d-flex align-items-center">
                <input
                  class="mr-2"
                  type="radio"
                  id="weekly"
                  value="weekly"
                  v-model="employeeDetails.subsidy_type"
                />
                <label for="weekly">Weekly</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div
            v-if="employeeDetails.subsidy_type == 'daily'"
            class="col-12 form-group edit-modal-item"
          >
            <label style="font-weight: 500">Daily Subsidy</label>
            <div
              class="d-flex flex-column flex-wrap flex-md-row dailyLimits_container mb-1"
            >
              <div class=" col-md-4 dailyLimit_item">
                <label>Monday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.monday"
                />
              </div>
              <div class=" col-md-4 dailyLimit_item">
                <label>Tuesday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.tuesday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Wednesday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.wednesday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Thursday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.thursday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Friday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.friday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Saturday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.saturday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Sunday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.sunday"
                />
              </div>
            </div>
          </div>

          <div v-else class="col-12 form-group edit-modal-item">
            <label style="font-weight: 500">Weekly Subsidy</label>
            <div class="row dailyLimits_container mb-1">
              <div class="col-4 dailyLimit_item form-group">
                <label>Subsidy</label>
                <input
                  v-clear
                  required
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.subsidy"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-1 mb-3">
          <div v-if="error" class="col-12 alert alert-danger alert-dismissible">
            <p>{{ this.error }}</p>
          </div>
          <div class="d-flex flex-column flex-md-row w-100 justify-content-end">
            <div class="d-flex align-items-center ml-md-0 ml-3 mb-2 mb-md-0">
              <input
                class="mr-2"
                type="checkbox"
                id="cutlery"
                v-model="sendEmail"
              />
              <label class="mb-0" for="cutlery">Send welcome email</label>
            </div>

            <div class="col my-1 my-md-0">
              <button type="submit" class="save_btn hover-dark">
                {{ isSoftDeleted ? "Revert" : "Invite" }}
              </button>
            </div>

            <div class="col my-1 my-md-0">
              <button
                type="button"
                class="other_btn hover-gray"
                @click="closeModal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import { saveEmployee, checkEmail } from "../../utils/api";
import { mapState, mapGetters } from "vuex";
import {
  isPresent,
  parseDailySubsidy,
  parseWeeklySubsidy
} from "@/utils/common";

export default {
  name: "AdminAddUserModal",
  data() {
    return {
      employeeDetails: {
        employee_id: "",
        email: "",
        first_name: "",
        last_name: "",
        team: "",
        designation: "",
        subsidy_type: "daily",
        subsidy: "",
        daily_subsidy: {
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0,
          sunday: 0
        },
        first_reminder: "no reminder",
        second_reminder: "no reminder",
        third_reminder: "no reminder"
      },
      modalWidth: "95%",
      officeTeams: [],
      allItems: 0,
      currentDailySubsidy: {},
      remainingDailySubsidy: {},
      dailyLunchSubsidy: [],
      dailyDinnerSubsidy: [],
      meal: "lunch",
      subsidy: "daily",
      error: "",
      sendEmail: true,
      reminderOptions: ["15", "30", "45", "60", "90", "120", "180"],
      disableFields: false,
      isSoftDeleted: false
    };
  },
  beforeDestroy() {
    document.body.classList.remove("noscroll");
  },
  mounted() {
    this.modalWidth = window.innerWidth >= 768 ? "70%" : "95%";
  },
  methods: {
    checkEmail() {
      if (this.employeeDetails.email) {
        this.isSoftDeleted = false;
        checkEmail(this.employeeDetails.email, this.getFirstEmployeeId).then(
          response => {
            const data = response?.data;
            let employee = data?.data?.attributes;
            if (employee) {
              this.employeeDetails.first_name = employee?.first_name;
              this.employeeDetails.last_name = employee.last_name;
              this.employeeDetails.first_reminder = employee.first_reminder;
              this.employeeDetails.second_reminder = employee.second_reminder;
              this.employeeDetails.third_reminder = employee.third_reminder;
              this.disableFields = true;

              let employees = employee.employees;
              let obj = employees.find(
                employee =>
                  employee.attributes.organization_type === "Location" &&
                  Number(employee.attributes.organization_id) ===
                    Number(
                      this.currentOrganization.attributes.organization_id
                    ) &&
                  employee.attributes.soft_deleted
              );

              if (isPresent(obj)) {
                this.isSoftDeleted = true;
              }
            }
          }
        );
      }
    },

    filterKey(e) {
      let key = e.keyCode || e.charCode;
      if (
        key !== 9 &&
        key !== 8 &&
        key !== 46 &&
        key !== 190 &&
        key !== 40 &&
        key !== 37 &&
        key !== 39 &&
        key !== 38
      ) {
        if (!e?.key?.trim() || isNaN(e.key)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }
    },
    beforeOpen(event) {
      this.employeeDetails = {
        employee_id: "",
        email: "",
        first_name: "",
        last_name: "",
        team: "",
        designation: "",
        subsidy_type: "daily",
        subsidy: "",
        daily_subsidy: {
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0,
          sunday: 0
        },
        first_reminder: "no reminder",
        second_reminder: "no reminder",
        third_reminder: "no reminder"
      };
      this.error = "";
      this.disableFields = false;
      this.officeTeams = JSON.parse(JSON.stringify(event?.params?.officeTeams));
      if (this.officeTeams.length == 1)
        this.employeeDetails.team = this.officeTeams[0].id;
    },
    beforeClose() {
      document.body.classList.remove("noscroll");
    },
    closeModal() {
      Object.assign(this.$data, this.$options.data());

      this.$modal.hide("addusermodal");
    },
    saveEmp() {
      const empDetails = this.employeeDetails;
      if (empDetails.email === "") {
        this.error = "You must provide a valid email";
        return;
      }
      if (empDetails?.first_name === "") {
        this.error = "You must provide a first name";
        return;
      }
      if (empDetails.last_name === "") {
        this.error = "You must provide a last name";
        return;
      }
      if (this.officeTeams && this.officeTeams.length > 0 && !empDetails.team) {
        this.error = "You must select a team";
        return;
      }

      const params = {
        email: empDetails.email,
        first_name: empDetails?.first_name,
        last_name: empDetails.last_name,
        first_reminder: empDetails.first_reminder,
        second_reminder: empDetails.second_reminder,
        third_reminder: empDetails.third_reminder,
        send_email: this.sendEmail,
        location_employee: {
          team_id: empDetails.team,
          designation: empDetails.designation,
          subsidy_type: empDetails.subsidy_type,
          role: "full_time",
          subsidy: parseWeeklySubsidy(empDetails.subsidy),
          daily_subsidy: parseDailySubsidy(empDetails.daily_subsidy)
        }
      };

      if (this.isSoftDeleted) {
        params.restore = true;
      }

      let loader = this.$loading.show();

      saveEmployee(params, this.getFirstEmployeeId)
        .then(res => {
          loader.hide();
          if (res.data && !res.data.employee)
            this.error =
              res.data.message instanceof Array
                ? res.data.message.join(",")
                : res.data.message;
          else {
            this.closeModal();
            this.$root.$emit("onGetEmployees");
          }
        })
        .catch(err => {
          loader.hide();
        });
    },
    isReminderChosen(timeSlot) {
      const currentSelectedReminders = [
        +this.employeeDetails.reminder_1_value,
        +this.employeeDetails.reminder_2_value,
        +this.employeeDetails.reminder_3_value
      ];
      return !currentSelectedReminders.includes(timeSlot);
    }
  },
  computed: {
    ...mapGetters(["getFirstEmployeeId"]),
    ...mapState(["currentOrganization"]),
    updatedReminderOptions() {
      const currentSelectedReminders = [
        +this.employeeDetails.reminder_1_value,
        +this.employeeDetails.reminder_2_value,
        +this.employeeDetails.reminder_3_value
      ];
      const availableReminderOptions = [...this.reminderOptions].filter(
        option => {
          if (+option === +currentSelectedReminders[0]) {
            return false;
          }

          if (+option === +currentSelectedReminders[1]) {
            return false;
          }

          if (+option === +currentSelectedReminders[2]) {
            return false;
          }
          return true;
        }
      );

      return [...availableReminderOptions];
    }
  },
  directives: {
    clear: {
      bind: function(el, binding, vnode) {
        el.onfocus = function() {
          if (parseFloat(el.value) === 0) {
            el.value = null;
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 24px;
  font-weight: 700;
}

.dailyLimit_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 8px;
}

.dailyLimit_item input {
  width: 140px;
}

.dailyLimit_item label {
  font-size: 14px;
  font-weight: normal;
  color: #000;
  margin-bottom: 6px;
}

.col {
  flex-grow: 0;
}

.modal--container {
  padding: 0 20px;
}

@media (max-width: 768px) {
  .dailyLimit_item input {
    width: 100%;
  }

  .save_btn {
    width: 100%;
  }

  .other_btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/AdminAddUserModal.vue